/*
 * CHANGELOG
 * Date: 2026-09-22
 * Editor: Cord, via Perplexity Computer
 * What changed: Activate deferred zoom image URLs on modal open, not initial page load.
 * Where: assets/product-modal.js
 * Rollback theme: Homepage V2 - Sep 2 2026 (180400357623); pre-edit asset snapshot saved.
 */
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      this.loadDeferredImages(opener);
      super.show(opener);
      this.showActiveMedia();
    }

    loadDeferredImages(opener) {
      const activeId = opener.getAttribute('data-media-id');
      this.querySelectorAll('img[data-product-modal-src]').forEach((image) => {
        if (image.getAttribute('data-media-id') === activeId) image.loading = 'eager';
        const srcset = image.getAttribute('data-product-modal-srcset');
        if (srcset) image.setAttribute('srcset', srcset);
        image.setAttribute('src', image.getAttribute('data-product-modal-src'));
        image.removeAttribute('data-product-modal-srcset');
        image.removeAttribute('data-product-modal-src');
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
